import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Form,
  Container,
  Col,
  Row
} from "react-bootstrap";


import Guest from "../../../layouts/Guest";
import RegistrationWizard from "../../Forms/Private/EventRegistrationWizard/RegistrationWizard";
import LiangHuangRegistrationWizard from "../../Forms/Private/LiangHuangRegistrationWizard/RegistrationWizard";

function EventRegisterPage() {

  return (
    <>
      <Guest>
        <LiangHuangRegistrationWizard />
      </Guest>
    </>
  );
}

export default EventRegisterPage;
